import { CardRewardsEarnRate } from 'data/types/CardData';
import {
  generateDisclaimers,
  isBiltHousingWithSpendRatio,
} from '../utils/generateDisclaimers';

export const EarnRateConditionsMessage = ({
  rate,
  showSharedCategories = false,
  userSelectedCategories = [],
  currentCategory,
  onEditBiltSpendRatio,
  promotionalType,
  compact = false,
}: {
  rate: CardRewardsEarnRate;
  showSharedCategories?: boolean;
  userSelectedCategories?: string[][];
  currentCategory?: string;
  onEditBiltSpendRatio?: () => void;
  /** The promotional type that produced this earn rate, if any */
  promotionalType?: string | null;
  /** Use compact disclaimer format (e.g. "Requires spend†" instead of "With 25% spend ratio") */
  compact?: boolean;
}) => {
  const disclaimers = generateDisclaimers(rate, {
    compact,
    showSharedCategories,
    userSelectedCategories,
    currentCategory,
    promotionalType,
  });

  const showBiltSpendRatioMessage = isBiltHousingWithSpendRatio(rate);

  if (disclaimers.length === 0 && !showBiltSpendRatioMessage) {
    return null;
  }

  // Use em dash prefix for all disclaimers for consistency
  const prefix = '— ';

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        marginTop: '4px',
        marginBottom: 0,
        gap: '2px',
      }}
    >
      {showBiltSpendRatioMessage && (
        <p
          style={{
            fontSize: '12px',
            color: '#6488A3',
            margin: 0,
            lineHeight: '1.2',
          }}
        >
          {prefix}
          Requires spending relative to housing payments.{' '}
          {onEditBiltSpendRatio && (
            <button
              onClick={onEditBiltSpendRatio}
              style={{
                background: 'none',
                border: 'none',
                color: '#1976d2',
                cursor: 'pointer',
                fontSize: '12px',
                padding: 0,
                textDecoration: 'underline',
              }}
            >
              Edit
            </button>
          )}
        </p>
      )}
      {disclaimers.length > 0 && (
        <p
          style={{
            fontSize: '12px',
            color: '#6488A3',
            margin: 0,
            lineHeight: '1.2',
          }}
        >
          {prefix}
          {disclaimers.join('. ')}
        </p>
      )}
    </div>
  );
};
